import { GET_RESIDENT_LISTING_FAILURE, GET_RESIDENT_LISTING_SUCCESS } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_RESIDENT_LISTING_SUCCESS:
			return onSuccess(state, action);
		case GET_RESIDENT_LISTING_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
